export const LOGBOOK = 'lb'
export const PROJECTED_SITES_MANAGER = 'psm'
export const LOOKUP_TABLE_SINGLE = 'lts'
